var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitsIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 53,
    viewBox: "0 0 91 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9646 50.7731C16.7368 50.7731 18.984 48.5536 18.984 45.8158C18.984 43.0779 16.7368 40.8584 13.9646 40.8584C11.1925 40.8584 8.94525 43.0779 8.94525 45.8158C8.94525 48.5536 11.1925 50.7731 13.9646 50.7731Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.73 50.7731C43.5022 50.7731 45.7494 48.5536 45.7494 45.8158C45.7494 43.0779 43.5022 40.8584 40.73 40.8584C37.9579 40.8584 35.7106 43.0779 35.7106 45.8158C35.7106 48.5536 37.9579 50.7731 40.73 50.7731Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9841 45.8159H35.7135",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7494 45.8158H50.7688C51.6932 45.8158 52.4429 45.0754 52.4429 44.1624V35.9011C52.4429 34.9881 51.6932 34.2477 50.7688 34.2477H44.0782L34.5298 24.8173C34.2169 24.5084 33.7914 24.333 33.3489 24.333H9.84148C9.28346 24.333 8.76208 24.6086 8.45206 25.0678L2.25745 34.2449V44.1569C2.25745 45.0698 3.00711 45.8102 3.93151 45.8102H8.9509",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0782 34.2505H2.25464",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0568 21.8419V10.4519H78.281V48.2069",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7453 2.22681H7.59247V10.452H88.7453V2.22681Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8522 23.7403V17.8337H69.4203V48.2069H57.0339",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsIcon2);
export default __webpack_public_path__ + "static/media/benefits_icon2.e2b39f24d1bebc216ba3a4e5ca9af280.svg";
export { ForwardRef as ReactComponent };